import { QuestionType } from '@enums/survey.enum';

/**
 * Configuración de la pregunta según su tipo
 */
export class SurveyConfigDto {
  options?: string[];
  min_value?: number;
  max_value?: number;
  placeholder?: string;

  constructor(data?: Partial<SurveyConfigDto>) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

/**
 * DTO para un elemento individual de respuesta de encuesta devuelto por el backend
 */
export class SurveyAnswerItemDto {
  question_id: number = 0;
  question: string = '';
  answer: string = '';
  question_type?: QuestionType;
  config?: SurveyConfigDto;

  constructor(data?: Partial<SurveyAnswerItemDto>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  static fromJson(data: any): SurveyAnswerItemDto {
    return new SurveyAnswerItemDto({
      question_id: data?.question_id ?? 0,
      question: data?.question ?? '',
      answer: data?.answer ?? '',
      question_type: data?.question_type,
      config: data?.config ? new SurveyConfigDto(data.config) : undefined,
    });
  }
}
